import { motion } from "framer-motion";
import { useQuery } from "@tanstack/react-query";
import { MessageSquare, Hash } from "lucide-react";
import { fetchConfig } from "@/lib/api";
import SectionHeader from "@/components/SectionHeader";

const FEED = [
  { channel: "nba-talk", user: "MP Research", tag: "STAFF", text: "Board is live — 6 games tonight. Best Bet writeup drops at 4 PM ET.", time: "2:04 PM" },
  { channel: "props-lab", user: "Dray", tag: "VIP", text: "That Edwards usage breakdown was exactly what I needed. Riding 1U.", time: "3:41 PM" },
  { channel: "member-wins", user: "Keisha", tag: "VIP", text: "SGA over cashed again. +0.90U on the night, units tracker updated.", time: "11:52 PM" },
  { channel: "results", user: "MP Ledger", tag: "STAFF", text: "Yesterday: 2-1, +0.81U. Full ledger updated on the site.", time: "9:10 AM" },
];

export function Community() {
  const { data: config } = useQuery({ queryKey: ["config"], queryFn: fetchConfig, staleTime: 300_000 });
  const url = config?.whop?.vip_checkout_url || "/#pricing";

  return (
    <section className="border-y border-[#1E2738] bg-[#0A0D14]" data-testid="community-section">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 py-16 sm:px-6 sm:py-24 lg:grid-cols-2 lg:px-8">
        <div>
          <SectionHeader
            eyebrow="Community"
            title="More Than Picks."
            sub="Members talk NBA games, props, betting ideas, live games, results and member wins — every single night. Discord is the current home of the community and a membership benefit, not the whole product."
            testid="community-header"
          />
          <a
            href={url}
            target={url.startsWith("http") ? "_blank" : undefined}
            rel="noopener noreferrer"
            data-testid="join-community-btn"
            className="btn-outline"
          >
            <MessageSquare size={16} /> Join The Community
          </a>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.5 }}
          className="panel overflow-hidden"
          data-testid="community-feed-mock"
        >
          <div className="flex items-center justify-between border-b border-[#1E2738] px-5 py-3.5">
            <span className="font-display text-sm font-bold uppercase tracking-wider text-white">Money Printer · Member Feed</span>
            <span className="tag border border-[#00E676]/40 bg-[#00E676]/10 text-[#00E676]">
              <span className="live-dot h-1.5 w-1.5 rounded-full bg-[#00E676]" /> Live
            </span>
          </div>
          <div className="divide-y divide-[#1E2738]/70">
            {FEED.map((m, i) => (
              <div key={i} className="flex gap-3.5 px-5 py-4">
                <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg font-display text-xs font-bold ${
                  m.tag === "STAFF" ? "bg-[#00E676]/15 text-[#00E676]" : "bg-[#1A2234] text-slate-300"
                }`}>
                  {m.user.slice(0, 2).toUpperCase()}
                </span>
                <div className="min-w-0">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="text-sm font-semibold text-white">{m.user}</span>
                    <span className={`tag ${m.tag === "STAFF" ? "bg-[#00E676]/15 text-[#00E676]" : "bg-[#F59E0B]/15 text-[#F59E0B]"}`}>{m.tag}</span>
                    <span className="font-mono text-[10px] text-slate-500">{m.time}</span>
                  </div>
                  <p className="mt-1 text-sm leading-relaxed text-slate-400">{m.text}</p>
                  <p className="mt-1.5 flex items-center gap-1 font-mono text-[10px] uppercase tracking-wider text-slate-600">
                    <Hash size={10} /> {m.channel}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <p className="border-t border-[#1E2738] px-5 py-3 font-mono text-[10px] uppercase tracking-wider text-slate-600">
            Illustrative example of the kind of discussion in the Discord — not real member messages. Community lives on Discord for VIP members.
          </p>
        </motion.div>
      </div>
    </section>
  );
}

export default Community;
